import { EnumHelper, EventState, EventUserState } from "ui/Scripts/source/models/enums";
import { IModifyUser, ModifyUser } from "ui/Scripts/source/models/user/modifyUser";
import { Base } from "ui/Scripts/source/framework/base";

export interface IEventListItem {
    id: string;
    companyId: string;
    createCompanyId: string;
    unitCode: string;
    urgencyClassCode: string;
    urgencyClassColor: string;
    code: string;
    name: string;
    date: number;
    description: string;
    observer: string;
    observerAction: string;
    observerActionInUse: boolean;
    state: EventState;
    userState: EventUserState;
    immediateAction: string;
    preventiveAction: string;
    rootCause: string;
    isRead: boolean;
    locked: boolean;
    imported: boolean;
    exported: boolean;
    removable: boolean;
    published: boolean;
    messageCount: number;
    createUser: IModifyUser;
    modifyUser: IModifyUser;
    handlers: IModifyUser[];
    eventTypes: string;

    stateStr: string;
    getModifyDate(): number;
}

export class EventListItem implements IEventListItem {
    id: string;
    companyId: string;
    createCompanyId: string;
    unitCode: string;
    urgencyClassCode: string;
    urgencyClassColor: string;
    code: string;
    name: string;
    date: number;
    description: string;
    observer: string;
    observerAction: string;
    observerActionInUse: boolean;
    state: EventState;
    userState: EventUserState;
    immediateAction: string;
    preventiveAction: string;
    rootCause: string;
    isRead: boolean;
    locked: boolean;
    imported: boolean;
    exported: boolean;
    removable: boolean;
    published: boolean;
    messageCount: number;
    createUser: ModifyUser;
    modifyUser: ModifyUser;
    handlers: ModifyUser[];
    eventTypes: string;

    stateStr: string;

    constructor();
    constructor(obj: IEventListItem);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.companyId = obj && obj.companyId || "";
        this.createCompanyId = obj && obj.createCompanyId || "";
        this.unitCode = obj && obj.unitCode || "";
        this.urgencyClassCode = obj && obj.urgencyClassCode || "";
        this.urgencyClassColor = obj && obj.urgencyClassColor || "";
        this.code = obj && obj.code || "";
        this.name = obj && obj.name || "";
        this.date = obj && obj.date || 0;
        this.description = obj && obj.description || "";
        this.observer = obj && obj.observer || "";
        this.observerAction = obj && obj.observerAction || "";
        this.observerActionInUse = obj && obj.observerActionInUse || false;
        this.state = obj && obj.state || EventState.Draft;
        this.userState = obj && obj.userState || EventUserState.NotHandler;
        this.immediateAction = obj && obj.immediateAction || "";
        this.preventiveAction = obj && obj.preventiveAction || "";
        this.rootCause = obj && obj.rootCause || "";
        this.isRead = obj && obj.isRead || false;
        this.locked = obj && obj.locked || false;
        this.imported = obj && obj.imported || false;
        this.exported = obj && obj.exported || false;
        this.removable = obj && obj.removable || false;
        this.published = obj && obj.published || false;
        this.messageCount = obj && obj.messageCount || 0;
        this.createUser = new ModifyUser(obj ? obj.createUser : null);
        this.modifyUser = new ModifyUser(obj ? obj.modifyUser : null);
        this.handlers = ModifyUser.sortModifyUsers(Base.getTypedArray(obj ? obj.handlers : null, ModifyUser));
        this.eventTypes = obj && obj.eventTypes || "";

        this.stateStr = EnumHelper.EventStateToStr(this.state);
    }

    getModifyDate(): number {
        return this.modifyUser?.date ?? 0;
    }
}